import React, { Fragment, useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { category as categoryUtils } from 'utils';
import { useListingData, useGTM } from 'hooks';
import { inCategorySearchShape } from 'shapes';
import InCategorySearchListControl, {
    SLIDE_DIRECTIONS,
} from '../InCategorySearchListControl';
import InCategorySearchList from '../InCategorySearchList';
import { computeSliderNextPosition } from './utils';

const SLIDER_MOVE = 450;

let firstElementInSliderWidth = 0;
let lastElementInSliderWidth = 0;

export const InCategorySearchSlider = ({ values }) => {
    const [, pushToGTM] = useGTM();
    const sliderEl = useRef();
    const [sliderPosition, setSliderPosition] = useState(0);
    const [sliderControlsVisibility, setSliderControlsVisibility] = useState({
        featureActive: false,
        leftControllerActive: false,
        rightControllerActive: false,
    });

    const { listingData } = useListingData();
    useEffect(() => {
        pushToGTM({
            is_in_category_search: listingData.type === 'category',
        });
    }, []);
    const moveSlider = clickedDirection => {
        if (Object.values(SLIDE_DIRECTIONS).indexOf(clickedDirection) === -1)
            return;
        const direction =
            clickedDirection === SLIDE_DIRECTIONS.PREVIOUS ? 1 : -1;
        const { parentWidth, width } = categoryUtils.getNodesWidth(
            sliderEl.current,
        );

        const { position, limits } = computeSliderNextPosition({
            elementWidth: width,
            parentWidth,
            currentPosition: sliderPosition,
            direction,
            increment: SLIDER_MOVE,
            firstElementInSliderWidth,
            lastElementInSliderWidth,
        });
        setSliderPosition(position);
        setSliderControlsVisibility({
            ...sliderControlsVisibility,
            leftControllerActive: position < limits.left,
            rightControllerActive: position !== limits.right,
        });
    };

    const checkSliderStatus = () => {
        if (!sliderEl.current) return;
        setSliderPosition(0);
        const { parentWidth, width } = categoryUtils.getNodesWidth(
            sliderEl.current,
        );
        const isControlNeeded = width > parentWidth;
        setSliderControlsVisibility({
            ...sliderControlsVisibility,
            featureActive: isControlNeeded,
            leftControllerActive: false,
            rightControllerActive: isControlNeeded,
        });

        const sliderElements = sliderEl.current?.childNodes[0].childNodes;
        if (sliderElements.length > 0) {
            firstElementInSliderWidth = sliderElements[0].offsetWidth;
            lastElementInSliderWidth =
                sliderElements[sliderElements.length - 1].offsetWidth;
        }
    };

    // Handle window resize and then check controls status
    useEffect(() => {
        window.addEventListener('resize', checkSliderStatus);
        return () => window.removeEventListener('resize', checkSliderStatus);
    }, []);
    useEffect(() => {
        if (sliderEl.current) checkSliderStatus();
    }, [values, sliderEl]);

    return (
        <Fragment>
            <div className="intra-category__header">
                <FormattedMessage
                    id="listing.search.category.title"
                    defaultMessage="Search in the category :"
                    description="InCategorySearch title"
                />
            </div>
            <div className="intra-category__filters-wrapper">
                <div className="intra-category__controller">
                    <div
                        className="intra-category__slider"
                        ref={sliderEl}
                        style={{
                            transform: `translate3d(${sliderPosition}px, 0, 0)`,
                        }}
                    >
                        <InCategorySearchList values={values} />
                    </div>
                    {sliderControlsVisibility.featureActive &&
                        sliderControlsVisibility.leftControllerActive && (
                            <InCategorySearchListControl
                                direction="previous"
                                onClick={moveSlider}
                            />
                        )}
                    {sliderControlsVisibility.featureActive &&
                        sliderControlsVisibility.rightControllerActive && (
                            <InCategorySearchListControl
                                direction="next"
                                onClick={moveSlider}
                            />
                        )}
                </div>
            </div>
        </Fragment>
    );
};

InCategorySearchSlider.propTypes = {
    values: inCategorySearchShape.isRequired,
};

InCategorySearchSlider.displayName = 'InCategorySearchSlider';

export default InCategorySearchSlider;
